import AppointmentBarChart from "./components/appointBarChart";
import MedicationPieChart from "./components/medicationPieChart";
import PatientHealthLine from "./components/patientHealthLine";
import PatientStatsCard from "./components/patientStatsCard";


const PatientDashboard = () => {
  return (
    <div className="min-h-screen bg-slate-50 p-8">
      <h1 className="text-3xl font-bold text-slate-800 mb-8">
        Patient Overview
      </h1>

      {/* Stats */}
      <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-8">
        <PatientStatsCard
          title="Upcoming Appointments"
          value="2"
          subtitle="Next: 12 Feb 2026"
        />
        <PatientStatsCard
          title="Active Prescriptions"
          value="5"
          subtitle="Updated yesterday"
        />
        <PatientStatsCard
          title="Health Score"
          value="88%"
          subtitle="Excellent condition"
        />
      </div>

      {/* Charts */}
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
        <PatientHealthLine />
        <AppointmentBarChart />
        <MedicationPieChart />
      </div>
    </div>
  );
};

export default PatientDashboard;